import { API } from "../../Common/lib/api";
import { getUserSession } from "../../Common/lib/Session";

export default async function deleteProject(projectId, sk, title) {
  const session = await getUserSession();

  const result = await API.projects.update({
    id: projectId,
    userID: session.username,
    publishStatus: "archived",
  });
  return result.data.updateProject;
}
